import { uuid } from '../../utils/js.js';

const getTitle = (title, validations) => {
    let newTitle = title;
    if (validations && validations.indexOf('required') !== -1) {
        if (title.indexOf('*') === -1) {
            newTitle = `${title} *`;
        }
    }
    return newTitle;
};
/**
 * Calcola il valore di presentazione.
 */
class Presentation {
    constructor({ readOnly }) {
        this.readOnly = readOnly;
    }
    format(value) {
        if ((!value || value.length === 0) && this.readOnly)
            return '-';
        return value;
    }
    parse(text) {
        if (text === '-' && this.readOnly)
            return '';
        return text;
    }
}
const getRandomId = () => uuid();

export { Presentation, getRandomId, getTitle };
